module.exports = __webpack_public_path__ + "img/landscape-left-image.4fbc196f.svg";